import { Head, router, useForm } from "@inertiajs/react"

import type {
  ForumCategory,
  ForumPostFormData,
  Neighborhood,
} from "@/components/forum/forum-post-form"
import { ForumPostForm } from "@/components/forum/forum-post-form"
import AppLayout from "@/layouts/app-layout"
import { forumPostPath } from "@/routes"

interface ForumPostsEditProps {
  post: {
    id: number
    title: string
    content: string
    category?: { id: number; name: string } | null
    neighborhood?: { id: number; name: string } | null
    city?: { id: number; name: string } | null
    visibility: "neighborhood" | "city" | "country" | "global"
    is_pinned?: boolean
    tags?: string[]
  }
  categories: ForumCategory[]
  neighborhoods: Neighborhood[]
  can_pin?: boolean
}

export default function ForumPostsEdit({
  post,
  categories,
  neighborhoods,
  can_pin = false,
}: ForumPostsEditProps) {
  const initial: ForumPostFormData = {
    title: post.title || "",
    content: post.content || "",
    category_id: (post.category?.id ?? "").toString(),
    neighborhood_id: (post.neighborhood?.id ?? "").toString(),
    visibility: post.visibility || "city",
    is_pinned: Boolean(post.is_pinned),
    tags: Array.isArray(post.tags) ? post.tags.join(", ") : "",
  }

  const { data, setData, put, processing, errors } = useForm<{
    forum_post: ForumPostFormData
  }>({ forum_post: initial })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    put(forumPostPath(post.id))
  }

  const err = errors as unknown as Record<string, string>

  return (
    <AppLayout>
      <Head title={`Editar ${post.title}`} />

      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <ForumPostForm
          title="Editar post"
          data={data.forum_post}
          errors={err}
          categories={categories}
          neighborhoods={neighborhoods}
          processing={processing}
          onChange={(partial) =>
            setData("forum_post", { ...data.forum_post, ...partial })
          }
          onSubmit={submit}
          onCancel={() => router.visit(forumPostPath(post.id))}
          submitLabel="Guardar cambios"
          can_pin={can_pin}
        />
      </div>
    </AppLayout>
  )
}
